import { parse } from 'querystring';
import { ParsedQuery } from 'query-string';
import { Transformer as HashTransformer } from 'hooks/use-hash';
import { ViewPresetId } from '../scheduler-config/view-presets/constants';

export const toViewPresetId = (value: string): ViewPresetId | null => {
  switch (value) {
    case 'day':
      return ViewPresetId.Day;
    case 'day-zoomed':
      return ViewPresetId.DayZoomed;
    case 'week':
      return ViewPresetId.Week;
    case 'week-zoomed':
      return ViewPresetId.WeekZoomed;
    case 'month':
      return ViewPresetId.Month;
    case 'month-zoomed':
      return ViewPresetId.MonthZoomed;
    default:
      return null;
  }
};

const from_view_preset_hash =
  (validViewPresets: ViewPresetId[]) =>
  (parsed: ParsedQuery): ViewPresetId => {
    const group = parsed.zoomLevel
      ? typeof parsed.zoomLevel === 'string'
        ? toViewPresetId(parsed.zoomLevel)
        : toViewPresetId(parsed.zoomLevel[0])
      : null;

    return group != null && validViewPresets.includes(group)
      ? group
      : validViewPresets[0] ?? ViewPresetId.Week;
  };

const getParsed = (query): ParsedQuery =>
  parse((query ?? '').replace('#', '')) as unknown as ParsedQuery;

export const from_hash =
  (validViewPresets: ViewPresetId[]) =>
  (query: string): ViewPresetId =>
    from_view_preset_hash(validViewPresets)(getParsed(query));

export const viewPresetTransformer = (
  validViewPresets: ViewPresetId[],
): HashTransformer<ViewPresetId> => ({
  from: from_view_preset_hash(validViewPresets),
  to: (value: ViewPresetId) => {
    return { zoomLevel: value.toString() };
  },
});
